module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/private/tmp/recon-frankdev/react-hooks-slides/deck.mdx"
  }
}];